import { useEffect, useState } from 'react';
import { s } from './Pattern.styles';
import AnalysisCriteria from './AnalysisCriteria';
import CorePattern from './CorePattern';
import SpecialPattern from './SpecialPattern';
import { usePatternContext } from '../../../../context/PatternContext';
import PatternService from '../../../../service/Pattern';
import { Pattern1, Pattern2, Pattern3 } from './data';
import SelectedItem from '../selectedIItem';

const TABS = ['분석기준', '핵심 알고리즘', '특수 알고리즘'];

interface Props {
  isEditMode?: boolean;
  setIsEditMode?: (value: boolean) => void;
}

const PatternBox = ({ isEditMode, setIsEditMode }: Props) => {
  const { selectedTab } = usePatternContext();

  const renderTabContent = () => {
    if (selectedTab === '분석 기준') {
      return (
        <>
          <s.Container>
            <s.PatternBox>
              <AnalysisCriteria />
            </s.PatternBox>
          </s.Container>
          <SelectedItem tab={'핵심 알고리즘'} />
          <SelectedItem tab={'특수 알고리즘'} />
        </>
      );
    }
    if (selectedTab === '핵심 알고리즘') {
      return (
        <>
          <SelectedItem tab={'분석 기준'} />
          <s.Container>
            <s.PatternBox>
              <CorePattern />
            </s.PatternBox>
          </s.Container>
          <SelectedItem tab={'특수 알고리즘'} />
        </>
      );
    }
    if (selectedTab === '특수 알고리즘') {
      return (
        <>
          <SelectedItem tab={'분석 기준'} />
          <SelectedItem tab={'핵심 알고리즘'} />
          <s.Container>
            <s.PatternBox>
              <SpecialPattern />
            </s.PatternBox>
          </s.Container>
        </>
      );
    } else return null;
  };

  return (
    <s.Wrapper style={{ padding: '24px 16px 145px' }}>
      {renderTabContent()}
    </s.Wrapper>
  );
};

export default PatternBox;
